import * as Yup from 'yup';

interface IErrors {
  amountMin: string,
  notNumber: string,
}

function validationSchema(errors: IErrors) {
  return Yup.object().shape({
    field: Yup.number()
      .transform((value, originalValue) => originalValue === "" ? null : value)
      .nullable()
      .notRequired()
      .test('is-number', errors.notNumber, val => val === null || val === undefined || !isNaN(val))
      .test('min', errors.amountMin, val => val === null || val === undefined || val > 0)
  });
}

export const validationAmountNotRequiredField = (val: any, errors: IErrors) => {
  const value = { field: val };

  const schema = validationSchema(errors);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
